import mergeMaps from "../../../utils/merge-maps";
import getDefaultOptions from "./get-default-options";

/**
 *
 * @param {OptionsListMapProps | null} local
 * @param {OptionsListMapProps} [common]
 * @returns {OptionsListMapProps}
 */
const mergeOptions = (local, common) => {
  /** Get the default options */
  const defaults = /** @type {OptionsListMapProps} */ (getDefaultOptions());

  /** Get the merging map */
  const merge = common ? mergeMaps(common, defaults) : defaults;

  /** Merged options */
  const result = /** @type {OptionsListMapProps} */ (
    mergeMaps(local, merge)
  );

  return result;
};

export default mergeOptions;
